import { MAIN_COLOR } from 'shared/consts';
import styled from 'styled-components';

export const Image = styled.img`
	height: 24px;
`;

export const ImageContainer = styled.div`
	height: 27px;
`;

export const Container = styled.div<{selected: boolean}>`
	background: ${props => props.selected ? MAIN_COLOR : 'white'};
	color: ${props => props.selected ? 'white' : 'black'};
	border-radius: 48px;
	width: 69px;
	height: 54px;
	cursor: pointer;
`;
